/*global define*/
define('core/directives/dnaPlaceholderDirective',['angular'], function (angular) {
    'use strict';
    angular.module('dnaApp').directive('dnaPlaceholder', ['$timeout', function ($timeout) {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function ($scope, $el, attr) {

                var value;

                function _placehold () {
                    $el.val(attr.dnaPlaceholder);
                    $el.addClass('placeholder');
                }
                function _unplacehold () {
                    $el.val('');
                    $el.removeClass('placeholder');
                }

                $scope.$watch(attr.ngModel, function (val) {
                    value = val || '';
                });

                $el.on('focus', function () {
                    if (value == '') {
                        _unplacehold();
                    }
                });

                $el.on('blur', function () {
                    if ($el.val() == '') {
                        _placehold();
                    }
                });

                $timeout(function () {
                    if ($el.val() == '') {
                        _placehold();
                    }
                }, 500);
            }
        };
    }]);
});

